module.exports = __webpack_public_path__ + "img/gaming-dmd.d8c3aed5.jpg";